import { render, staticRenderFns } from "./EditTickerLinkedBoards.vue?vue&type=template&id=2ea23628&scoped=true"
import script from "./EditTickerLinkedBoards.vue?vue&type=script&lang=js"
export * from "./EditTickerLinkedBoards.vue?vue&type=script&lang=js"
import style0 from "./EditTickerLinkedBoards.vue?vue&type=style&index=0&id=2ea23628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea23628",
  null
  
)

export default component.exports